import { features } from '@/mocks/appData';

export default function FeatureSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            为什么选择 CPP 官方版
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            六大核心优势，为您带来安全纯净的移动应用体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-sm">
                {feature.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}